<ng-container *ngIf="isEnabled">

  <button
    *ngIf="!isOpen"
    type="button"
    class="ftue-inspector__handle"
    title="FTUE inspector (dev only)"
    (click)="toggle()">
    <ui-icon name="Lightbulb" size="small"></ui-icon>
    <span>FTUE</span>
  </button>

  <div class="ftue-inspector" *ngIf="isOpen">
    <div class="ftue-inspector__header">
      <span class="ftue-inspector__title">FTUE inspector</span>
      <span class="ftue-inspector__hint">dev only</span>
      <button type="button" class="ftue-inspector__icon-btn" (click)="toggle()" title="Close">
        <ui-icon name="X" size="small"></ui-icon>
      </button>
    </div>

    <div class="ftue-inspector__row" *ngFor="let tip of tips">
      <div class="ftue-inspector__meta">
        <span class="ftue-inspector__id">{{ tip.id }}</span>
        <span class="ftue-inspector__sub">
          {{ tip.tone }} · v{{ tip.version }} · p{{ tip.priority }} · {{ tip.anchor || 'no anchor' }}
        </span>
      </div>
      <span
        class="ftue-inspector__dot"
        [ngClass]="anchorResolves(tip) ? 'ftue-inspector__dot--on' : 'ftue-inspector__dot--off'"
        [title]="anchorResolves(tip) ? 'Anchor resolves on this page' : 'Anchor not on this page'">
      </span>
      <span class="ftue-inspector__seen" [ngClass]="{ 'ftue-inspector__seen--yes': hasSeen(tip) }">
        {{ hasSeen(tip) ? 'seen' : 'unseen' }}
      </span>
      <button type="button" class="ftue-inspector__btn" (click)="fire(tip)" title="Request it, rules apply">
        Fire
      </button>
      <button type="button" class="ftue-inspector__btn" (click)="preview(tip)" title="Force it, rules bypassed">
        Preview
      </button>
    </div>

    <div class="ftue-inspector__footer">
      <button type="button" class="ftue-inspector__btn" (click)="toggleTips()">
        Tips: {{ tipsEnabled ? 'on' : 'off' }}
      </button>
      <button type="button" class="ftue-inspector__btn" (click)="resetHistory()">Reset history</button>
    </div>
  </div>
</ng-container>
